import React from "react";
import Icon from "./Icon";


export default function File(props) {
  return (
    <div className="ds-file">
      <input
        type="file"
        accept={props.accept}
        onChange={props.onChange}
      />

      <Icon icon="image" />
      <p>{props.label}</p>
      <span>{props.hint}</span>
    </div>
  )
}


/*

Usage:

<File label="" hint="" />

- label: String
- hint: String

*/
